
<div>
  <p v-if="educationNameText" class="text-grey-body">{{ educationNameText }}</p>
  <p v-if="educationSubText" class="text-grey-body flex text-small items-center mt-8">{{ educationSubText }}</p>
</div>
